package top.wcpe.allincore.dsl.ir.model.hud

/**
 * Phase 4：单个 keybinding 条目 IR 节点。
 *
 *  - `id` — 绑定标识符（如 "openSkillPanel"）
 *  - `defaultKey` — 默认按键（可空；支持简化名 / GLFW 键名 / 数值）
 *  - `label` — ControlsScreen 中显示的名称（可空；支持翻译键或直接文本）
 *  - `onTriggerBytes` — onTrigger 语句字节码
 */
class UiKeyBinding(
    id: String,
    // val 属性生成 getDefaultKey() / getLabel()，与原 Java getter 名一致。
    val defaultKey: String?,
    val label: String?,
    onTriggerBytes: ByteArray?,
) {

    // val 属性生成 getId()，与原 Java getId() 一致；构造时非空校验。
    val id: String = requireNotNull(id) { "id" }

    // 防御式拷贝：入参数组构造时复制，避免外部持有引用篡改内部字节。
    private val onTriggerBytesInternal: ByteArray? = onTriggerBytes?.copyOf()

    // 属性 + 自定义 getter：Java 侧仍见 getOnTriggerBytes() 返回防御式拷贝，Kotlin 侧以 .onTriggerBytes 访问。
    val onTriggerBytes: ByteArray?
        get() = onTriggerBytesInternal?.copyOf()

    override fun toString(): String =
        "UiKeyBinding{id='" + id + "', defaultKey='" + defaultKey + "', label='" + label + "'}"

    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other !is UiKeyBinding) return false
        return id == other.id &&
            defaultKey == other.defaultKey &&
            label == other.label &&
            onTriggerBytesInternal.contentEquals(other.onTriggerBytesInternal)
    }

    // 逐位复刻：先 Objects.hash(id, defaultKey, label)（种子 1、31 倍累乘），再 31*result + Arrays.hashCode(onTriggerBytes)。
    override fun hashCode(): Int {
        var result = 1
        result = 31 * result + id.hashCode()
        result = 31 * result + (defaultKey?.hashCode() ?: 0)
        result = 31 * result + (label?.hashCode() ?: 0)
        result = 31 * result + onTriggerBytesInternal.contentHashCode()
        return result
    }
}
